import { ary, includes, partial, some } from 'lodash-es';

/**
 * 두 collection 간에 교집합 시, 값이 있는지 확인.
 */
export function hasIntersection<T>(collection1: ArrayLike<T>, collection2: ArrayLike<T>) {
  return some(collection1, ary(partial(includes, collection2), 1));
}
